import { gql } from '@apollo/client';

export const GET_HOURLY_TRANSITION_HISTORY = gql`
  query GetHourlyTransitionHistory($date: String!) {
    getHourlyTransitionHistory(date: $date) {
      id
      date
      completedHour
      transitionTimestamp

      posOriginalTarget
      posAdaptiveTarget
      posActualSales
      posSalesCount
      posOriginalPercentage
      posAdaptivePercentage

      taxOriginalTarget
      taxAdaptiveTarget
      taxActualAmount
      taxSalesCount
      taxOriginalPercentage
      taxAdaptivePercentage

      dailyPosTarget
      dailyPosCumulativeSales
      dailyPosOverallPercentage
      dailyTaxTarget
      dailyTaxCumulativeAmount
      dailyTaxOverallPercentage

      remainingHoursSnapshot {
        hour
        posOriginalTarget
        posAdaptiveTarget
        posAssignedPercentage
        taxOriginalTarget
        taxAdaptiveTarget
        taxAssignedPercentage
      }
      recalculationExplanation

      systemOpinion
      trendAssessment
      confidenceLevel
      confidenceReason

      modStateAtTransition
      autoControlEnabled
      predictiveControlEnabled

      createdAt
    }
  }
`;

export const GET_LATEST_HOURLY_TRANSITION = gql`
  query GetLatestHourlyTransition {
    getLatestHourlyTransition {
      id
      date
      completedHour
      systemOpinion
      trendAssessment
      confidenceLevel
      dailyPosOverallPercentage
      dailyTaxOverallPercentage
    }
  }
`;
